import { openResetPasswordModal } from '../State/resetPasswordModal'

export default () => (dispatch) => {

  dispatch(openResetPasswordModal())
  
}
